<script>

    export default {
        name: "Setting",

        data() {
            return {
                mode: '',
                // by: this.redirect_url + '/list-by-permission',
                by : null,
            }
        },

        props : {
            redirect_url : {
                type: String,
                required: true,
            },
            init_mode : {
                type: String,
                default : 'permission',
            },
        },

        methods: {
            toggleMode(mode) {
                if(mode == this.mode) return;
                if (mode == 'permission') {
                    this.mode = 'permission';
                    this.by = this.redirect_url + '/list-by-permission';
                } else if (mode == 'role'){
                    this.mode = 'role';
                    this.by = this.redirect_url + '/list-by-role';
                } else {
                    this.mode = 'user';
                    this.by = this.redirect_url + '/list-by-user';
                }

            },
            refresh() {
                let _url = this.by;
                let self = this;
                this.by = '';
                this.$nextTick(function(){
                    self.by = _url;
                })
            },

        },

        beforeMount() {
            if(this.init_mode) {
                this.toggleMode(this.init_mode);
            } else {
                this.mode = 'permission';
                this.toggleMode(this.mode);
            }
        },
        mounted() {
			window.eventHub.$on('refresh-data', this.refresh)
        },
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/Modules/system-management/administrator/Setting.vue